<template>
    <div class="CheckboxListF" dir="rtl">
        <div class="objs">
            <div class="position-relative col-12 p-1 pointer objFilterBtn" @click="openCloseFilter">
                <span class="CheckboxListF-span me-2">{{text}}</span>
            </div>
            <hr style="height: 0.5px;color: #aaaaaa;" class="my-2" v-if="openClose">
            <div class="objFilterList scroll-me" v-if="openClose">
                <div class="col-12 mb-2 p-1" v-if="search">
                    <input class="form-control Searchfield" type="search" v-model="query" placeholder="جستجو" aria-label="Search" />
                </div>
                <hr style="height: 0.5px;color: #aaaaaa;" class="my-2" v-if="search">

                <div class="objsChild" :key="obj" v-for="obj in result">
                    <div class="CheckboxListFA col-12">
                        <label class="container-checkbox d-flex">
                            <input :value="obj.id" v-model="checkbox" type="checkbox" class="obj-checkbox pointer">
                            <i v-if="checkbox.indexOf(obj.id) != -1" class="fa-solid fa-square-check CheckboxListF-icon pointer checked" ></i>
                            <i v-if="checkbox.indexOf(obj.id) == -1" class="fa-solid fa-square CheckboxListF-icon pointer"></i>
                            <span class="title-obj pointer">{{obj.name}}</span>
                        </label>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CheckboxListF',
  props: {
    text: String,
    name: String,
    objects: Array,
    search: Boolean
  },
  data () {
    return {
      openClose: false,
      checkbox: [],
      query: null
    }
  },
  methods: {
    openCloseFilter: function () {
      if (!this.openClose) {
        this.openClose = true
      } else {
        this.openClose = false
      }
    }
  },
  computed: {
    result () {
      if (this.query) {
        return this.objects.filter((item) => {
          return this.query.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
        })
      } else {
        return this.objects
      }
    }
  },
  watch: {
    checkbox (to, from) {
      this.addFilter(this.name, this.checkbox)
    }
  },
  mounted () {
    try {
      this.$route.query[this.name].split(',').forEach(str => {
        this.checkbox.push(Number(str))
      })
    } catch {}
  }
}
</script>
<style scoped>
.scroll-me{
  max-height: 230px;
  overflow: auto;
}
.oc-icon{
  left: 0;
  color: #aaaaaa;
}
.CheckboxListF-span{
  color: #4c4b4b;
  font-weight: 500;
  font-size: 14px;
}
.objs{
  background: #FFFFFF;
  border: solid 2px #e4e4e4;
  border-radius: 19px;
  padding: 10px;
}
.Searchfield{
  background: #F7F7F7;
  border-radius: 19px;
  border: none;
}
.objsEN{
  float:left;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;
  text-align: left;
  padding-left:5px;
  color: #4F4F4F;
  margin-top: 4px;
}
.CheckboxListFA{
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;
  text-align: right;
  color: #4F4F4F;
}
.objsChild{
  padding: 7px 6px;
}
.obj-checkbox{
  position: absolute;
  opacity: 0;
}
.CheckboxListF-icon{
  width: 18px;
  font-size: 14pt;
  color: gray;
}
.title-obj{
  margin: 0px 3px;
  display: block;
}
.checked{
  color: #e98b78;
}
</style>
